import { gql } from "../__generated__/gql";

export const START_SIGNATURE_PROCESS = gql(`
   mutation startSignatureProcess($contractId: ID!) {
      startSignatureProcess(contractId: $contractId) {
        signState
        signUrl
        emailSent
        quality
        signedAssetId
      }
    }
`);

export const RESET_SIGNATURE_PROCESS = gql(`
    mutation resetSignatureProcess($contractId: ID!) {
        resetSignatureProcess(contractId: $contractId) {
            success
        }
    }
`);

export const START_SAMPLE_SIGNATURE = gql(`
   mutation startSampleSignature {
      startSampleSignature {
        signState
        signUrl
        emailSent
        quality
      }
    }
`);
